import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { View, Button, Image } from '@zhike/ti-ui';
import { createPromise } from 'utils/action';
import AudioCtx from '../audioCtx';
import styles from './styles';


const tipBoxData = [
  { url: './assets/button_play.png', text: '播放/暂停' },
  { url: './assets/button_pre.png', text: '返回上一句' },
  { url: './assets/button_next.png', text: '进入下一句' },
  { url: './assets/button_original.png', text: '显示/隐藏原文' },
  { url: './assets/button_translation.png', text: '显示/隐藏译文' },
  { url: './assets/button_circulation.png', text: '重读当前句' },
  { url: './assets/forward.png', text: '快进3秒' },
  { url: './assets/backward.png', text: '快退3秒' },
];

// 页面头部
export default class Content extends Component {
  // 参数
  static defaultProps = {
    listenPart: {},
  };

  static propTypes = {
    listenPart: PropTypes.object,
    match: PropTypes.object.isRequired,
    isListen: PropTypes.bool.isRequired,
    listenId: PropTypes.number.isRequired,
    postListenComplete: PropTypes.func.isRequired,
    postListenReset: PropTypes.func.isRequired,
    hasTranslation: PropTypes.bool.isRequired, // 是否有中文译文
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isListen: props.isListen,
      sentenceIndex: 0,
      clickRawNum: 0, // 点击raw的次数，为了判断在全文是否是点击raw
      isFullText: 1, // 1 全文，0 单句
      isShowText: {
        0: 0,
        1: 0,
      }, // key是isFullText的值 1 显示原文，0 隐藏原文
      isShowTranslation: {
        0: 0,
        1: 0,
      }, // key是isFullText的值 1 显示译文，0 隐藏译文
      isWelcomeShow: true, // true 显示欢迎页，false 隐藏欢迎页
      isBtnload: false,
      playing: false, // 音频的播放状态
      uploaded: false, // 音频转化为二进制流
    };
  }

  // 模块加载
  componentDidMount() {
    // 键盘按下监听事件
    global.document.addEventListener('keydown', this.keyboardPress);
  }

  // 模块接受参数
  componentWillReceiveProps(nextProps) {
    if (this.props.listenPart.src !== nextProps.listenPart.src) {
      this.setState({
        sentenceIndex: 0,
        isFullText: 1,
        playing: false,
        isShowText: {
          0: 0,
          1: 0,
        },
        isShowTranslation: {
          0: 0,
          1: 0,
        },
      });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    /* eslint-disable */
    if (this.sentence && this.fullText && prevState.sentenceIndex !== this.state.sentenceIndex) {
      // ReactDOM.findDOMNode(this.sentence).scrollIntoView({ block: "center", behavior: 'smooth' });
      // setTimeout(() => {}, 300);
      const fullTextNode = ReactDOM.findDOMNode(this.fullText);
      const sentenceNode = ReactDOM.findDOMNode(this.sentence);
      const sentenceHeight = sentenceNode.offsetHeight;
      const sentenceTop = sentenceNode.offsetTop;
      const fullTextHeight = fullTextNode.clientHeight;
      const newScrollTop = sentenceTop + (sentenceHeight / 2) - (fullTextHeight / 2);

      if ((fullTextHeight / 2) > sentenceTop) {
        fullTextNode.scrollTop = 0;
      } else {
        fullTextNode.scrollTop = newScrollTop;
      }
    }
    /* eslint-enable */
  }

  componentWillUnmount() {
    // 卸载键盘按下监听事件
    global.document.removeEventListener('keydown', this.keyboardPress);
  }

  // 键盘按下
  keyboardPress = event => {
    const { keyCode } = event;
    switch (keyCode) {
      case 32: // 空格
        // 禁止浏览器默认行为
        if (event.preventDefault) {
          event.preventDefault();
        }
        if (this.audioChild && this.state.uploaded) this.audioChild.handleClickPlay();
        break;
      case 37:
        if (event.preventDefault) {
          event.preventDefault();
        }
        if (this.audioChild) this.audioChild.handelForwardBackward(false);
        break;
      case 39:
        if (event.preventDefault) {
          event.preventDefault();
        }
        if (this.audioChild) this.audioChild.handelForwardBackward(true);
        break;
      case 188: // <
        if (!this.state.isWelcomeShow) this.handlePrev();
        break;
      case 190: // >
        if (!this.state.isWelcomeShow) this.handleNext();
        break;
      case 219:
        if (!this.state.isWelcomeShow) this.handleOriginTextShow();
        break;
      case 221:
        if (!this.state.isWelcomeShow) this.handleTranslationShow();
        break;
      case 17:
        if (!this.state.isWelcomeShow) this.audioChild.handelRepeat();
        break;
      default:
        break;
    }
  }

  // 生成tipBox
  generateTipBox() {
    return (
      <View className={styles.tipBox}>
        <View>快捷键操作指南</View>
        <View className={styles.tipLine} />
        {
          tipBoxData.map((item, index) => (
            <View key={index} className={styles.tipItem}>
              <Image className={styles.tipItemKey} src={require(`${item.url}`)} />
              {item.text}
            </View>
          ))
        }
      </View>
    );
  }

  // 生成top导航
  generateTop() {
    const { isShowText, isFullText, isShowTranslation, uploaded } = this.state;
    const { hasTranslation } = this.props;
    return (
      <View className={styles.top}>
        <View className={styles.btns}>
          <View onClick={() => this.handleFullTextShow(1)} className={[styles.btn, isFullText === 1 && styles.selectedBtn]}>全文精听</View>
          <View onClick={() => this.handleFullTextShow(0)} className={[styles.btn, isFullText === 0 && styles.selectedBtn, !uploaded && styles.disable]}>单句精听</View>
        </View>
        <View className={styles.btns2}>
          <View className={styles.lBox}>
            <View className={styles.listeningBtn}>显示原文</View>
            <View
              className={[styles.strip, isShowText[isFullText] && styles.stripActive]}
              onClick={() => this.handleOriginTextShow()}
            >
              <View className={[styles.round, isShowText[isFullText] && styles.roundActive]} />
            </View>
          </View>
          <View className={styles.lBox}>
            <View className={[styles.listeningBtn, !hasTranslation && styles.noTranslation]}>显示译文</View>
            <View
              className={[
                styles.strip,
                isShowTranslation[isFullText] && styles.stripActive,
                !hasTranslation && styles.noTranslation,
              ]}
              onClick={() => { this.handleTranslationShow(); }}
            >
              <View className={[styles.round, isShowTranslation[isFullText] && styles.roundActive]} />
            </View>
          </View>
        </View>
      </View>
    );
  }

  // 全文还是单句
  handleFullTextShow(value) {
    const { isFullText } = this.state;
    if (isFullText !== value) {
      this.setState({ isFullText: value, sentenceIndex: 0, isWelcomeShow: false, playing: false });
    }
  }

  // 是否显示原文
  handleOriginTextShow() {
    const { isShowText, isFullText, isWelcomeShow } = this.state;
    if (isWelcomeShow) return false;
    isShowText[isFullText] = isShowText[isFullText] === 0 ? 1 : 0;
    this.setState({ isShowText });
  }

  // 是否显示译文
  handleTranslationShow() {
    const { isShowTranslation, isFullText, isWelcomeShow } = this.state;
    if (!this.props.hasTranslation) return false;
    if (isWelcomeShow) return false;
    isShowTranslation[isFullText] = isShowTranslation[isFullText] === 0 ? 1 : 0;
    this.setState({ isShowTranslation });
  }

  // 是否完成
  async handleComplete() {
    const { isListen, isBtnload } = this.state;
    if (isBtnload) return false;
    this.setState({ isBtnload: true });
    const { postListenComplete, postListenReset, listenId } = this.props;
    const search = global.location.search; // eslint-disable-line
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const taskId = decodeURIComponent(search.match(new RegExp('[?#&]task_id=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    if (isListen) {
      await createPromise(postListenReset, {
        id: listenId,
        source,
        taskId: taskId || null,
      });
    } else {
      await createPromise(postListenComplete, {
        id: listenId,
        source,
        taskId: taskId || null,
      });
    }
    this.setState({ isListen: !isListen, isBtnload: false });
  }

  setSentenceIndex = index => {
    const { sentenceIndex } = this.state;
    if (index !== -1 && index !== sentenceIndex) {
      this.setState({ sentenceIndex: index });
    }
  }

  // 隐藏欢迎页
  hiddenWelcome = () => {
    this.setState({ isWelcomeShow: false });
  }

  // 上一句
  handlePrev = () => {
    const { sentenceIndex, clickRawNum } = this.state;
    if (sentenceIndex === 0) return false;
    this.setState({
      sentenceIndex: sentenceIndex - 1,
      clickRawNum: clickRawNum + 1,
    });
  }

  // 下一句
  handleNext = () => {
    const { sentenceIndex, clickRawNum } = this.state;
    const { listenPart } = this.props;
    const translation = listenPart.translation || [];
    if (sentenceIndex === translation.length - 1) return false;
    this.setState({
      sentenceIndex: sentenceIndex + 1,
      clickRawNum: clickRawNum + 1,
    });
  }

  // 点击raw 跳转到相应的音频
  handleClickRaw = index => {
    const { clickRawNum } = this.state;
    this.setState({
      sentenceIndex: index,
      clickRawNum: clickRawNum + 1,
    });
  }

  // 获取音频的播放状态
  getPlaying = value => {
    this.setState({ playing: value });
  }

  // 音频加载完毕
  handleCompleted = () => {
    this.setState({ uploaded: true });
  }

  // 渲染
  render() {
    const { listenPart, hasTranslation } = this.props;
    const { isShowText, isShowTranslation, isListen, sentenceIndex, isBtnload,
      isWelcomeShow, isFullText, clickRawNum, playing } = this.state;
    const translation = listenPart.translation || [];
    const src = listenPart.src || '';
    return (
      <View className={styles.container}>
        {this.generateTop()}
        <View className={styles.contentBox}>
          {
            isWelcomeShow &&
            <View className={[styles.content, styles.welcomeContent]}>
              <View className={styles.welcomeBg}>
                <Image className={styles.welcomeIcon} src={require('components/assets/default.png')} />
              </View>
              <View className={styles.welcomeH1}>Hi~ 欢迎使用智课精听</View>
              <View className={styles.welcomeP}>点击下方 <View className={styles.welcomeP2}>播放按钮</View> 或按 <View className={styles.welcomeP2}>空格键</View> 播放</View>
              {/* <View className={styles.welcomeImage} /> */}
            </View>
          }
          {
            !isWelcomeShow && isFullText === 1 &&
            <View
              className={styles.content}
              ref={ref => { this.fullText = ref; }}
            >
              {
                translation.map((item, index) => {
                  if (item.raw) {
                    let selectedRow;
                    if (sentenceIndex === index) {
                      selectedRow = styles.color385DAE;
                    }
                    return (
                      <View
                        key={index}
                        className={[styles.paragraph, selectedRow]}
                        ref={ref => { if (sentenceIndex === index) this.sentence = ref; }}
                        onClick={() => this.handleClickRaw(index)}
                      >
                        {
                          selectedRow && playing &&
                          <Image className={styles.selectedIcon} src={require('./assets/select_loading.gif')} />
                        }
                        {
                          selectedRow && !playing &&
                          <Image className={[styles.selectedIcon, styles.selectedIconPlay]} src={require('./assets/select.png')} />
                        }
                        <View className={[
                          styles.sentence,
                          !isShowText[isFullText] && styles.sentenceHide,
                          selectedRow && !isShowText[isFullText] && styles.sentenceHideSelected,
                          ]}
                        >
                          {item.raw}
                        </View>
                        <View className={[
                          styles.sentence,
                          !isShowTranslation[isFullText] && styles.sentenceHide,
                          selectedRow && !isShowTranslation[isFullText] && styles.sentenceHideSelected,
                          !hasTranslation && styles.hasNoTranslation,
                          ]}
                        >
                          {item.translation}
                        </View>
                      </View>
                    );
                  }
                  return null;
                })
              }
              <View className={styles.bottom}>
                <Button
                  className={[styles.bottomButton, isListen && styles.isListen]}
                  text={isListen ? '已完成' : '点击完成'}
                  loading={isBtnload}
                  onClick={() => this.handleComplete()}
                />
                <View className={styles.bottomText}>任务标记为完成状态，方便下次查找哦~</View>
              </View>
            </View>
          }
          {
            !isWelcomeShow && isFullText === 0 &&
            <View className={[styles.content, styles.sentenceContent]}>
              <View className={styles.sentenceTop}>
                {sentenceIndex + 1}/{translation.length}
                <View className={styles.sentenceBtns}>
                  <Button
                    className={[styles.sentenceBtn, sentenceIndex === 0 && styles.disable]}
                    text="上一句"
                    onClick={() => this.handlePrev()}
                  />
                  <Button
                    className={[styles.sentenceBtn, sentenceIndex === (translation.length - 1) && styles.disable]}
                    text="下一句"
                    onClick={() => this.handleNext()}
                  />
                </View>
              </View>
              <View className={[styles.paragraph, styles.sentenceParagraph]}>
                <View className={[styles.sentence, !isShowText[isFullText] && styles.sentenceHideSelected]}>
                  {translation[sentenceIndex] && translation[sentenceIndex].raw}
                </View>
                <View
                  className={[
                    styles.sentence,
                    !isShowTranslation[isFullText] &&
                    styles.sentenceHideSelected,
                    !hasTranslation && styles.hasNoTranslation,
                  ]}
                >
                  {translation[sentenceIndex] && translation[sentenceIndex].translation}
                </View>
              </View>
              {
                sentenceIndex === translation.length - 1 &&
                <View className={[styles.bottom, styles.marginTop0]}>
                  <Button
                    className={[styles.bottomButton, isListen && styles.isListen]}
                    text={isListen ? '已完成' : '点击完成'}
                    loading={isBtnload}
                    onClick={() => this.handleComplete()}
                  />
                  <View className={styles.bottomText}>任务标记为完成状态，方便下次查找哦~</View>
                </View>
              }
            </View>
          }
          {this.generateTipBox()}
        </View>
        <View className={styles.audio}>
          <View className={styles.audioContent}>
            <AudioCtx
              ref={ref => { this.audioChild = ref; }}
              src={src}
              handleCompleted={this.handleCompleted}
              handleNext={this.handleNext}
              handlePrev={this.handlePrev}
              handleClickRaw={this.handleClickRaw}
              getPlaying={this.getPlaying}
              clickRawNum={clickRawNum}
              translation={translation}
              isFullText={isFullText}
              sentenceIndex={sentenceIndex}
              setSentenceIndex={this.setSentenceIndex}
              hiddenWelcome={this.hiddenWelcome}
            />
          </View>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listen/content/index.js